import React, { FC, useCallback, useMemo, useState } from 'react';
import { Button, Form, Input, Modal, message } from 'antd';
import { connect } from 'react-redux';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { dropOffToolForSupplier } from '../../thunks/tools_thunks';
import ToolInfoHeader from './ToolInfoHeader';
import { getContactName } from '../../utils/DataFormatterUtils';

const FORM_NAME = 'drop-off-tool-form';

const DropOffModal: FC<any> = ({
	visible,
	tool,
	onCancel,
	onSuccess,
	dropOffTool,
}): React.ReactElement => {
	const [saving, setSaving] = useState(false);

	const contactName = useMemo(
		() => getContactName(nullSafeGet('currentCheckout.pickedUpForContact', tool)).trim(),
		[tool]
	);

	const onSubmit = useCallback(
		(values) => {
			setSaving(true);
			dropOffTool(tool.id, { dropOffNotes: values.dropOffNotes })
				.then(() => {
					onSuccess();
				})
				.catch((err) => message.error(err))
				.finally(() => setSaving(false));
		},
		[tool, dropOffTool, onSuccess]
	);

	return (
		<Modal
			visible={visible}
			width={600}
			title={'Drop Off for ' + contactName}
			onCancel={onCancel}
			closable={true}
			footer={[
				<Button key="cancel" onClick={onCancel} size="large">
					Cancel
				</Button>,
				<Button
					type="primary"
					size="large"
					style={{ marginLeft: '16px' }}
					key="submit"
					htmlType="submit"
					form={FORM_NAME}
					loading={saving}
				>
					Drop Off
				</Button>,
			]}
		>
			<ToolInfoHeader tool={tool} />
			<Form id={FORM_NAME} layout="vertical" requiredMark={false} onFinish={onSubmit}>
				<Form.Item name="dropOffNotes" label="Notes">
					<Input.TextArea placeholder="Add a note..." autoSize={{ minRows: 3 }} />
				</Form.Item>
			</Form>
		</Modal>
	);
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
	dropOffTool: (toolId, data) => dispatch(dropOffToolForSupplier(toolId, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DropOffModal);
